import {
  kttDetail,
  kttEdit,
} from '@/api/prod/center'

// 过滤上传失败或为空的图片
export function _filterInvalidImg(imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
}
// 处理JSON转换的通用函数
function _handleJSON(data, isStringify) {
  return isStringify ? JSON.stringify((data || []).filter(Boolean)) : JSON.parse(data || '[]')
}

// 处理数组分隔/连接的通用函数
function _handleArray(data, isJoin) {
  if (!data) return []
  return isJoin ? data.join(',') : data.split(',')
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList?.length) {
    r.skuList = r.skuList.map(item => {
      const skuSpecifications = _handleJSON(item.skuSpecifications, isRequest)
      const _skuid = isRequest ? "" : skuSpecifications.map(sp => sp.valueKey).filter(Boolean).join('-')
      return {
        ...item,
        _skuid,
        skuSpecifications
      }
    })
  }
  // 需要JSON转换的字段
  const transformJsonList = ['specifications', 'picUrl']
  // 需要数组转换的字段
  const transformArrayList = []
  transformJsonList.forEach(key => {
    r[key] = _handleJSON(r[key], isRequest)
  })
  transformArrayList.forEach(key => {
    r[key] = _handleArray(r[key], isRequest)
  })
  return r

}

// 编辑详情
export function editKttInfo(data) {
  const list = (data || []).map(item => {
    return _formatGoodsItem(item, true)
  })
  return kttEdit(list).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getKttDetail(params) {
  return kttDetail(params).then(res => {
    if (res.result === 1) {
      return (res.data || []).map(item => {
        return _formatGoodsItem(item)
      })
    } else {
      return false
    }
  })
}



